import { render, staticRenderFns } from "./AuctionCollectionSelectInputWidget.vue?vue&type=template&id=05096008&scoped=true"
import script from "./AuctionCollectionSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./AuctionCollectionSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05096008",
  null
  
)

export default component.exports